import React from 'react';
import { useNavigate } from 'react-router-dom';

function ConversationListItem({ conversation, currentUserId, onClick }) {
  const navigate = useNavigate();
  const handleClick = () => {
    if (onClick) onClick(conversation);
    else navigate(`/messages/${conversation.id}`);
  };

  const participants = conversation.participants || [];
  const otherParticipant = participants.find(
    (p) => (p.user?.id ?? p.id) !== currentUserId
  );
  const otherUser = otherParticipant?.user ?? otherParticipant ?? participants[0]?.user ?? participants[0];
  const displayName =
    otherUser?.first_name || otherUser?.last_name
      ? [otherUser.first_name, otherUser.last_name].filter(Boolean).join(' ')
      : otherUser?.email || 'Unknown';
  const lastMessage = conversation.last_message;
  const unreadCount = conversation.unread_count ?? 0;

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-full flex items-center gap-3 p-4 text-left border-b border-gray-200 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset rounded-none"
    >
      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-medium">
        {(displayName[0] || '?').toUpperCase()}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className="font-medium text-gray-900 truncate">{displayName}</span>
          {lastMessage?.created_at && (
            <span className="text-xs text-gray-500 flex-shrink-0">
              {new Date(lastMessage.created_at).toLocaleDateString(undefined, {
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })}
            </span>
          )}
        </div>
        {lastMessage && (
          <p className="text-sm text-gray-600 truncate mt-0.5">
            {lastMessage.content || 'New message'}
          </p>
        )}
      </div>
      {unreadCount > 0 && (
        <span className="flex-shrink-0 min-w-[1.25rem] h-5 px-1.5 rounded-full bg-blue-600 text-white text-xs font-medium flex items-center justify-center">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
}

export default ConversationListItem;
